import React from "react";
import "./Sidebar.css";
import Image from "react-bootstrap/Image";
import { useLocation, NavLink } from "react-router-dom";

function AppSidebar({ isOpen, toggleSidebar }) {
    const location = useLocation();

    const isActive = (path) => (location.pathname === path ? "active-page" : "");

    // ✅ Collapse sidebar on mobile after clicking a menu item
    const handleMenuClick = () => {
        if (window.innerWidth <= 768) {
            setTimeout(() => {
                toggleSidebar();
            }, 200); // slight delay for smoothness
        }
    };

    const handlePostRequest = async () => {
        document.getElementById("redirect").submit();
    };

    return (
        <>
            {/* Hidden form for redirecting */}
            <form id="redirect" action="https://emstylemsk.net/shop/my-account/" method="POST" target="_top">
                <input type="hidden" name="username" value={sessionStorage.getItem("prov_email")} />
                <input type="hidden" name="password" value={sessionStorage.getItem("prov_password")} />
            </form>

            <div className={`app-sidebar ${isOpen ? "open" : ""}`}>
                <div className={`logo text-center ${isOpen ? "hidden-sidebar-logo" : ""}`}>
                    <Image src="../images/logo-light.png" width={150} className="img-fluid mx-auto d-block" />
                </div>

                <button className="close-btn" onClick={toggleSidebar}>
                    &times;
                </button>

                <div className="app-menu">
                    <ul className="accordion-menu">
                        <li className="sidebar-title">Menu</li>

                        <li className={isActive("/Provider/PatientList") || isActive("/Provider/PatientView")}>
                            <NavLink to="/Provider/PatientList" onClick={handleMenuClick}>
                                <i className="fa-solid fa-user-group" />
                                Patients
                            </NavLink>
                        </li>

                        <li className={isActive("/Provider/Settings")}>
                            <NavLink to="/Provider/Settings" onClick={handleMenuClick}>
                                <i className="fa-solid fa-gear" /> Settings
                            </NavLink>
                        </li>

                        <li className={isActive("/Provider/Profile")}>
                            <NavLink to="/Provider/Profile" onClick={handleMenuClick}>
                                <i className="fa-solid fa-user" /> Profile
                            </NavLink>
                        </li>

                        {/* Example external redirect using form */}
                        {/* 
                        <li>
                            <button
                                className="menu-btn"
                                onClick={() => {
                                    handlePostRequest();
                                    handleMenuClick();
                                }}
                            >
                                <i className="fa-solid fa-cart-shopping"></i>
                                Shop
                            </button>
                        </li>
                        */}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default AppSidebar;
